
import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { FormsModule } from '@angular/forms';
import { MatRadioGroup, MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { LimiterDirective } from '../directive/limiter';

@Component({
  selector: 'app-manage-file-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatRadioModule,
    FormsModule,
    MatRadioGroup,
    MatSelectModule,
    LimiterDirective
],
  template: `
<div [class]="data.class + ' bg-back text-copy ' ">
  <div class="bg-gold-500 font-bold flex items-center justify-between py-4 px-6">
    <span>{{ action }} {{ label }}</span>
    <!--<mat-icon (click)="dialogRef.close()">close</mat-icon>-->
  </div>
  <div mat-dialog-content>
    @for (information of info; track information) {
      <p>{{information}}</p>
    }
    <div class="flex items-center gap-2">
      <input 
        type="text"
        [limiter]="150"
        (keyup)="onKeyUp($event)"
        [(ngModel)]="result.inputValue"
      />
      @if(extension){
        <span class="mb-2">.{{extension}}</span>
      }
    </div>
    @if(data.folders.length > 1){
      <mat-radio-group class="flex flex-col mb-4" (change)="onSelectFolder($event.value)">
        @for(folder of data.folders; track folder.id; let folderIndex = $index){
          <mat-radio-button [checked]="folder.id === result.folderId" [value]="folder">{{folder.folderName}}</mat-radio-button>
        }
      </mat-radio-group>
    }
    <!-- <mat-select placeholder="Display Order" [(ngModel)]="result.displayOrder">
      @for(order of orderOptions; track order) {
        <mat-option [value]="order">{{order + 1}}</mat-option>
      }
    </mat-select> -->
  </div>
  <div class="bg-copy/10 flex justify-between py-4 px-6">
    <button mat-flat-button [mat-dialog-close]="false">{{close}}</button>
    @if (action) {
      <button mat-flat-button [mat-dialog-close]="result" color="primary">{{action}}</button>
    }
  </div>

</div>
`,
  styles: ['']
})
export class ManageFileDialogComponent implements OnInit {
  close = 'Close';
  label = 'Order';
  action = 'To Be Cancelled';
  info:string[] = []
  orderOptions = [0]
  extension?: string | null ;
  result: ManageFileDialogResult = {
    inputValue: '',
    // displayOrder: 0,
  }

  constructor(
    public dialogRef: MatDialogRef<ManageFileDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: ManageFileDialogData
  ) { }

  ngOnInit(): void {
    this.label  = this.data.label || this.label;
    this.action = this.data.action !== undefined ? this.data.action : this.action;
    this.info = this.data.info || this.info;
    if(this.data.selectedFolderId) {
      const selectedFolder = this.data.folders.find(f => f.id === this.data.selectedFolderId);
      if(selectedFolder) {
        this.result.folderId = selectedFolder.id;
        this.orderOptions = Array.from({ length: selectedFolder.contentLength + 1 }, (_, i) => i + 1);
        // this.result.displayOrder = selectedFolder.contentLength;
      }
    }
    else if(this.data.folders.length > 0) {
      const firstFolder = this.data.folders[0];
      this.result.folderId = firstFolder.id;
      this.orderOptions = Array.from({ length: firstFolder.contentLength + 1 }, (_, i) => i + 1);
      // this.result.displayOrder = firstFolder.contentLength;
    }
    this.result.inputValue = this.data.inputValue || this.result.inputValue;
    if(!!this.data.extension) {
      this.extension = this.data.extension;
      if(this.result.inputValue?.endsWith("." + this.extension)) {
        this.result.inputValue = this.result.inputValue.replace(new RegExp(`\\.${this.extension}$`), '');
      }
    }
    if(this.data.closeText){
      this.close = this.data.closeText;
    }
  }

  onSelectFolder(folder: DigitalFolderInfo): void {
    this.result.folderId = folder.id;
    this.orderOptions = Array.from({ length: folder.contentLength + 1 }, (_, i) => i + 1);
    // this.result.displayOrder = folder.contentLength;
  }

  onKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.dialogRef.close(this.result);
    }
  }

}

export interface DigitalFolderInfo {
  id: string
  folderName: string
  parentId: string | null
  // displayOrder: number
  contentLength: number
}

export interface ManageFileDialogData {
  class?: string
  closeText?: string
  label?: string
  inputValue?: string
  info?: string[]
  action: string
  folders: DigitalFolderInfo[]
  selectedFolderId?: string
  extension?: string | null
}

export interface ManageFileDialogResult {
  inputValue: string
  folderId?: string
  shouldDelete?: boolean
  // displayOrder?: number
}
